/*
  ボタンタグのデフォルトのスタイルを打ち消したコンポーネント。
  本来reset.css的なものを利用したいが、既存のユーティリティークラスがデフォルトのスタイルを前提にしているため、
  新規に作成するボタンのスタイリングにこちらを利用する。
*/
import { type FC } from "react";

import { unstyledButton } from "./styles.css";

type ButtonProps = JSX.IntrinsicElements["button"];

export const UnstyledButton: FC<ButtonProps> = ({ className, children, ...props }) => (
  <button type="button" {...props} className={`${unstyledButton} ${className || ""}`}>
    {children}
  </button>
);
